import React from 'react';
import Button from 'react-bootstrap/Button';

class CatalogSearchForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '', // Initialize the state for the input text
    };
  }

  handleInputChange = (event) => {
    this.setState({ searchText: event.target.value }); // Update the state when input changes
  };

  render() {
    return (
      <form
        id="catlogSearch"
        action="https://catalog.habib.edu.pk/cgi-bin/koha/opac-search.pl"
        method="get"
        target="_blank"
      >
        <div className='input-group'>
            <input
              type="text"
              name="q"
              className="form-control"
              value={this.state.searchText} // Bind input value to state
              onChange={this.handleInputChange} // Handle input change
              placeholder="Type book name, author or ID"
            />
            <Button type="submit"
              name="submit"
              value="Submit"
              className="btn btn-outline-secondary btn btn-primary">
              <img src='/assets/img/search-icon.svg' alt=""/> 
          </Button>
           
          {/* <aside className="csAdv">
            <a href="https://catalog.habib.edu.pk/cgi-bin/koha/opac-search.pl" target="_blank">
              Advanced Search
            </a>
          </aside> */}
        </div>
      </form>
    );
  }
}

export default CatalogSearchForm;
